import common from './common/translator.json';
import staffCommon from './staff/common/translator.json';
import staffCreditWallet from './staff/creditwallet/translator.json';
import staffTopupCredit from './staff/topupcredit/translator.json';
import staffAdjustCredit from './staff/adjustcredit/translator.json';
import staffPackage from './staff/package/translator.json';
import topupgame from './business/topupgame/translator.json';
import transaction_all from './staff/transaction_all/translator.json';
import businessSidebar from './business/sidebar/translator.json';
import staffSidebar from './staff/sidebar/translator.json';
import dashboard from './dashboard/translator.json';
import login from './login/translator.json';
import register from './register/translator.json';
import profile from './profile/translator.json';
import manageAccounts from './manage-accounts/translator.json';
import approveHistory from './manage-accounts/Approvehistory/translator.json';
import gameList from './game-list/translator.json';
import staffServerList from './staff/server-list/translator.json';
import staffSupplierList from './staff/supplier-list/translator.json';
import staffLineNotifyTargets from './staff/line-notify-targets/translator.json';
import staffSMSMonitor from './staff/sms-monitor/translator.json';
import staffOnlineMonitor from './staff/online-monitor/translator.json';
import staffBotMonitor from './staff/bot-monitor/translator.json';
import credittransaction from './business/credit-transaction/translator.json';
import reports from './reports/translator.json';
import staffDistributor from './staff/distributor/translator.json';
import staffTopupDiscountSetting from './staff/Topup-discount-setting/translator.json';
import staffPackageMarkup from './staff/Package-markup/translator.json';
import approveRequest from './manage-accounts/approve-request/translator.json';
import gameAndPackage from './business/game-and-package/translator.json';
import manageCustomers from './business/manage-customers/translator.json';
import customerDiscount from './business/customer-discount/translator.json';
import customerDiscountTier from './business/customer-discount-tier/translator.json';
import bankAccountManagement from './business/bank-management/translator.json';
import landingPage from './business/landing-page/translator.json';
import companyManagement from './business/company-management/translator.json';
import businessSettings from './business/settings/translator.json';
import partnerAPIKey from './business/partner-api-key/translator.json';
import storefrontTemplate from './business/storefront-template/translator.json';
import streamerManagement from './business/streamer-management/translator.json';

const translation = {
  ...common,
  ...staffCommon,
  ...staffCreditWallet,
  ...staffTopupCredit,
  ...staffAdjustCredit,
  ...staffPackage,
  ...topupgame,
  ...transaction_all,
  ...businessSidebar,
  ...staffSidebar,
  ...dashboard,
  ...login,
  ...register,
  ...profile,
  ...manageAccounts,
  ...approveHistory,
  ...gameList,
  ...staffServerList,
  ...staffSupplierList,
  ...staffLineNotifyTargets,
  ...staffSMSMonitor,
  ...staffOnlineMonitor,
  ...staffBotMonitor,
  ...credittransaction,
  ...reports,
  ...staffDistributor,
  ...staffTopupDiscountSetting,
  ...staffPackageMarkup,
  ...approveRequest,
  ...gameAndPackage,
  ...manageCustomers,
  ...customerDiscount,
  ...customerDiscountTier,
  ...bankAccountManagement,
  ...landingPage,
  ...companyManagement,
  ...businessSettings,
  ...partnerAPIKey,
  ...storefrontTemplate,
  ...streamerManagement,
};

export default translation;
